<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="two-thirds column">
          <div v-if="!status" class="slide">
            <h1>Loading...</h1>
          </div>

          <div v-if="status == 'morning'" class="slide">
            <h1>Welcome to the livestream of the 2021 Private Wealth Seminar from The Broadmoor in Colorado Springs</h1>
            <p>We will begin streaming at {{ startTimeToday }} {{ timezone }}</p>
          </div>

          <div v-if="status == 'evening'" class="slide">
            <h1>We will return at {{ startTimeTomorrow }} tomorrow</h1>
            <p>You can view today's footage in the archive listed above.</p>
          </div>

          <div v-if="status == 'comingSoon'" class="slide">
            <h1>Welcome to the livestream of the 2021 Private Wealth Seminar from The Broadmoor in Colorado Springs</h1>
            <p>We will begin streaming at {{ conferenceStartTime }} {{ timezone }} on {{ conferenceStartDate }}.</p>
          </div>

          <div v-if="status == 'over'" class="slide">
            <h1>Welcome to the livestream of the 2021 Private Wealth Seminar from The Broadmoor in Colorado Springs</h1>
            <p>Access to the presentations and the list of recommendations can be found above. Simply click on a presentation to begin watching.</p>
            <p>Scroll down to view the conference highlights.</p>
          </div>

          <div v-if="isLive">
            <!-- <h1>Welcome to the livestream of the 2021 Private Wealth Seminar from Colorado Springs</h1> -->
            <div class="flex-video">
              <iframe id="ls_embed_1489072940" :src="livestreamEmbed" width="100%" height="462" style="max-width: 100%;" frameborder="0" scrolling="no" allowfullscreen></iframe>
            </div>
          </div>
        </div><!-- .content -->
        <div class="one-third column">
          <LiveBlog />
        </div>
          
        <div class="col content">
          <Banner :presentationHash="getPresentationHash()" />
          <Sidebar />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';
import Banner from './Banner';
import LiveBlog from './LiveBlog';
import Sidebar from './Sidebar';

export default {
  name: 'Home',
  firebase: helpers.getFirebaseObject(db),
  components: { Sidebar, Banner, LiveBlog, },
  beforeMount() { auth.requireLogin(); },
  mounted() { this.updateData(); },
  data() {
    return {
      presentations: [],
      year: undefined,
      today: undefined,
      presentationHash: undefined,
      status: undefined,
      startTimeToday: undefined,
      startTimeTomorrow: undefined,
      isLive: false,
      activeArchiveLink: '',
      livestreamEmbed: undefined,
    }
  },
  methods: {

    updateData() {
      try {
        this.presentations = helpers.getPresentationsByDay(this.speakers, this.options);
        this.year = helpers.getYear();
        this.today = helpers.now();
        this.presentationHash = this.getPresentationHash();
        this.status = this.getStatus();
        this.startTimeToday = this.getStartTime(0);
        this.startTimeTomorrow = this.getStartTime(1);
        this.isLive = this.status === 'live' || !isNaN(this.status);
        this.activeArchiveLink = `/#/archive/${this.getCurrentDayNum()}`;
        this.livestreamEmbed = this.getLivestreamEmbed();
      }
      catch (err) {
        setTimeout(this.updateData, 500);
        return;
      }
      setTimeout(this.updateData, 60 * 1000);
    },

    getPresentationHash() {
      if (!this.speakers || !this.options) return;
      let presentations = helpers.getPresentationsByDay(this.speakers, this.options);
      let presentationHash = helpers.getConferenceStatus(presentations, this.offset);

      if (isNaN(presentationHash)) return;

      return presentationHash;
    },

    getStartTime(daysFromNow) {
      if (!this.presentations) return;

      let time = '';

      this.presentations.forEach((presentations, dayNum) => {
        let theDay = this.getDate(presentations[0]).getDate();

        if (this.today.getDate() + daysFromNow === theDay) {
          time = presentations[0].start_time;
          return;
        }
      });
      return time;
    },

    getCurrentDayNum() {
      if (!this.presentations) return;

      let dayNum = 0;

      this.presentations.forEach((presentations, i) => {
        let theDay = this.getDate(presentations[0]);
        if (theDay) { theDay = theDay.getDate(); }
        else { return; }

        if (this.today && this.today.getDate() === theDay) {
          dayNum = i + 1;
          return;
        }
      });
      return dayNum;
    },

    getDate(p) {
      if (p && 'date' in p && 'start_time' in p && this.offset) {
        return helpers.getTimestamp(p.date, p.start_time, this.offset);
      }
    },

    getStatus() {
      // console.log(helpers.getConferenceStatus(this.presentations, this.offset))
      return helpers.getConferenceStatus(this.presentations, this.offset);
    },

    getLivestreamEmbed() {
      try {
        let accountId = this.options.live_accountid;
        let dayNum = this.getCurrentDayNum();
        if (dayNum == 0) {
          return;
        }
        let eventId = helpers.getEventsByDay(this.days, dayNum.toString());
        return `https://livestream.com/accounts/${accountId}/events/${eventId}/player?width=1200&height=462&enableInfoAndActivity=true&defaultDrawer=&autoPlay=true&mute=false`;
      }
      catch (err) { console.log(err); }
    },
  },
  computed: {
    conferenceStartTime() { return this.presentations[0][0].start_time; },
    conferenceStartDate() { return this.presentations[0][0].date; },
    timezone() { return helpers.getTimezoneStr(this.offset); },
    offset() { return helpers.getUTCOffset(this.options); },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.one-third.column {
  width: 29.5%;
  margin-left: 1em;
}
.two-thirds.column {
  width: 69%;
}
@media screen and (max-width: 942px) {
  .one-third.column {
    width: 100%;
    margin-left: unset;
  }
  .two-thirds.column {
    width: 100%;
  }
}
.slide {
  background-color: #0B202B;
  border-top: 10px solid #6DC5CB;
  height: 462px;
  text-align: center;
  padding: 1rem;
  color: #fdfdfd;
  font-weight: bold;
  margin-bottom: 1rem;
}
.slide > h1 {
  font-size: 2.6em;
  border: 1px solid #fdfdfd;
  background: transparent;
}
.slide > p {
  margin-bottom: 40px;
  font-size: 2em;
  line-height: 1.2;
}
.slide > p > a {
  color: #fdfdfd;
}
.flex-video {
  margin-bottom: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue